
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-instagram/[label]",
      function () {
        return require("private-next-pages/top-instagram/[label].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-instagram/[label]"])
      });
    }
  